import { get } from "lodash";
import OnePayConfigAdapter from "./OnePayConfigAdapter";

const isValid = paymentData =>
  paymentData.partsService ||
  paymentData.inviteToPay ||
  paymentData.accounting ||
  paymentData.accountingInviteToPay ||
  paymentData.cancel;

const validate = paymentInfo => {
  const paymentData = OnePayConfigAdapter.adapt(paymentInfo).toJson();

  if (!isValid(paymentData)) {
    let message =
      "An error has occurred while trying to process a refund. The Payment does not match the business rules.";

    if (helper.isPayNowPartsService(paymentInfo)) {
      if (
        !paymentInfo.permissions.showPayNow &&
        !paymentInfo.permissions.showEbpp
      ) {
        message =
          "An error has occurred while trying to process a payment. Please verify the user has the Paynow or EBPP permission enabled in Report & Analyze, Setup Users for Payment.";
      }
    }

    return { isValid: false, message };
  }

  return { isValid: true };
};

const helper = {
  isPayNowPartsService: paymentInfo =>
    !helper.isAccounting(paymentInfo) &&
    !helper.isAccountingInviteToPay(paymentInfo) &&
    !helper.isCancelPayment(paymentInfo) &&
    !helper.isCreditMemo(paymentInfo),
  isAccounting: paymentInfo => paymentInfo.accFlag,
  isAccountingInviteToPay: paymentData => paymentData.accountingI2PFlag,
  isCancelPayment: paymentInfo => paymentInfo.balanceDue <= 0,
  isCreditMemo: paymentInfo =>
    get(paymentInfo, "documentId", "")
      .toUpperCase()
      .startsWith("CM")
};

export default { validate };
